export function manageZIndex(event) {
  let { target } = event;

  this.lastZ = this.lastZ ? this.lastZ+=1 : 1;
  target.style.zIndex = this.lastZ;
}


export function dragHandler(event) {
  let newX, newY;
  let { target, dx, dy } = event;

  // Ensure target always has higher z-index than siblings
  let siblingNodes = target.parentElement.children;

  newX = (parseFloat(target.getAttribute('data-x')) || 0) + dx;
  newY = (parseFloat(target.getAttribute('data-y')) || 0) + dy;
  target.style.webkitTransform = target.style.transform = `translate(${newX}px, ${newY}px)`;
  target.setAttribute('data-x', newX);
  target.setAttribute('data-y', newY);
}

export function resizeHandler(event) {
  let x, y;
  let { target, dx, dy } = event;
  x = (parseFloat(target.getAttribute('data-x')) || 0);
  y = (parseFloat(target.getAttribute('data-y')) || 0);

  if (event.rect.height <= 400 && event.rect.height >= 100 ) {
    // update the element's style
    target.style.width  = event.rect.width + 'px';
    target.style.height = event.rect.height + 'px';

    // translate when resizing from top or left edges
    x += event.deltaRect.left;
    y += event.deltaRect.top;

    target.style.webkitTransform = target.style.transform = 'translate(' + x + 'px,' + y + 'px)';
  }

  target.setAttribute('data-x', x);
  target.setAttribute('data-y', y);
}



// WEBPACK FOOTER //
// ./app/javascript/utils/interact.js